import { ReactElement, ReactNode, useState } from 'react';
import { ClickAwayListener } from '@mui/material';
import { CSSProperties, makeStyles } from '@mui/styles';

import { Placement } from './types';
import StandardTooltip from './standardTooltip';
import { useLongPress } from '../hooks/useLongPress';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    justifyContent: 'inherit',
    width: 'inherit',
    maxWidth: 'inherit'
  }
});
interface Props {
  title: NonNullable<ReactNode>;
  children: ReactElement<any, any>;
  offset?: [CSSProperties['offset'], CSSProperties['offset']];
  placement?: Placement;
}
const ClickableTooltip = ({ title, children, offset, placement }: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    if (!open) {
      return;
    }
    setOpen(false);
  };

  const handleTooltipToggle = () => {
    setOpen(prevState => !prevState);
  };
  const { onTouchStart, onTouchEnd } = useLongPress(handleTooltipToggle);

  return (
    <StandardTooltip
      offset={offset}
      placement={placement}
      open={open}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={title}
      arrow={false}
    >
      <div className={classes.wrapper} role="button" tabIndex={0} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        <ClickAwayListener onClickAway={handleTooltipClose}>{children}</ClickAwayListener>
      </div>
    </StandardTooltip>
  );
};

export default ClickableTooltip;
